import { getAuthUser, isAuthorised } from '../store/general/selectors';
import { getState } from '../store';
import _ from 'lodash';
import { ErrorRest } from '../../common/rest/error/errorRest';

export class ErrorEffects {

  private static sendErrorDebounce = _.debounce(ErrorEffects.sendError , 500);

  public static logError(e: Error | string) {
    try {
      const text: string = (e instanceof Error) ? e.message : e;
      console.error(e);

      const state = getState();
      // No session to report against, and /error/log itself requires one — sending here would
      // reject as another unhandled rejection, re-triggering this same handler forever.
      if (!isAuthorised(state)) return;

      const url = location?.href || '';
      const email = getAuthUser(state)?.email || '';

      let log = 'url: ' + url + '\n' +
        'email: ' + email + '\n' +
        'error: ' + text;
      if (e instanceof Error) {
        log += '\nstack: ' + e.stack;
      }

      ErrorEffects.sendErrorDebounce(log)
    } catch(e) {
      console.error(e);
    }
  }

  private static sendError(log: string) {
    ErrorRest.log(log).catch((e) => console.error(e));
  }

}
